import BaseRepository from "./BaseRepository";

export default new (class PriorityRepository extends BaseRepository {
  // POST api / partner / company_product_priorities { product_id, priority }
  updateProductPriority(product_id, priority) {
    return this.api.post(`/company_product_priorities/`, {
      company_product_priority: {
        product_id,
        priority,
      },
    });
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/PriorityRepository.js